import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import ImageSelector from "../common/ImageSelector";

export default function SectionImagesForm({ images, setImages, setDidChange }) {
  return (
    <Box flex={1}>
      <Paper
        elevation={3}
        sx={{
          padding: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          height: "100%",
          minHeight: "400px",
          position: "relative",
        }}
      >
        <Typography
          variant="h6"
          fontFamily="Trueno Light"
          sx={{ marginBottom: 1 }}
        >
          3. Upload Images
        </Typography>
        <Typography
          sx={{
            marginBottom: 2,
            marginX: 4,
            fontFamily: "Trueno Light",
            color: "#666",
            textAlign: "center",
            fontSize: 14,
          }}
        >
          Add up to 5 images in the order you want them to appear on Join, 1-1
          Aspect Ratio and up to 2Mb per image.
          <br />
          <strong>Supported files: .jpeg, .jpg, .png, .heic</strong>
        </Typography>
        <ImageSelector
          images={images}
          setImages={setImages}
          maxNumber={5}
          setDidChange={setDidChange}
          description="images"
        />
      </Paper>
    </Box>
  );
}
